import React from "react";
import { BsFillSuitHeartFill } from "react-icons/bs";
import { GiAustralia } from "react-icons/gi";
import { Flex, HStack, Icon, Image, Text, Box } from "@chakra-ui/react";
import { border } from "../constants/constants";
import sigFlat from "../assets/images/sigflat.png";
import { name } from "../constants/personalInfo";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <Box
      as="footer"
      id="footer"
      bg="brand.bg"
      borderTop="1px solid"
      borderColor={border}
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding="2rem"
      >
        <HStack>
          <Text fontSize="md" color="brand.muted">
            Made with{" "}
          </Text>
          <Icon
            as={BsFillSuitHeartFill}
            role="img"
            aria-label="love"
            color="red.400"
            boxSize="20px"
          />
          <Text fontSize="md" color="brand.muted">
            In{" "}
          </Text>
          <Icon
            as={GiAustralia}
            role="img"
            aria-label="Australia"
            color="brand.muted"
            boxSize="20px"
          />
          <Text fontSize="md" color="brand.muted">
            By{" "}
          </Text>
          <Image
            src={sigFlat}
            alt={name.fullName}
            boxSize="40px"
            filter="invert(0.85)"
          />
        </HStack>
        <Text fontSize="10px" color="brand.muted">
          Using ReactJs and Vercel.
        </Text>
        <Text fontSize="10px" color="brand.muted" mb={3}>
          © {year} {name.fullName} All Rights Reserved.
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
